import React, { useState } from "react";
import { NumberInputPage as PageType, UserProfile } from "../../types/quiz";
import { validateNumber } from "../../utils/quizLogic";
import '../../assets/scss/quiz-editorial.scss';

interface Props {
  page: PageType;
  userProfile: UserProfile;
  onAnswer: (value: number) => void;
}

const NumberInputPage: React.FC<Props> = ({ page, userProfile, onAnswer }) => {
  const initialValue = page.data_field
    ? (userProfile[page.data_field] as number) || ""
    : "";
  const [value, setValue] = useState<string>(initialValue.toString());
  const [error, setError] = useState<string | null>(null);
  const [showInfo, setShowInfo] = useState(false);

  const handleSubmit = () => {
    const numValue = parseInt(value);

    // Validate
    const validation = validateNumber(numValue, page.validation);
    if (!validation.valid) {
      setError(validation.error || "Invalid number");
      return;
    }

    // Submit
    setError(null);
    onAnswer(numValue);
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      handleSubmit();
    }
  };

  return (
    <div className="page page--number-input">
      <div className="page__container">
        <h2 className="page__question">{page.question}</h2>

        <div className="number-input">
          <input
            type="number"
            className={`number-input__field ${error ? "number-input__field--error" : ""}`}
            placeholder={page.placeholder}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            onKeyPress={handleKeyPress}
            min={page.validation?.min}
            max={page.validation?.max}
            autoFocus
          />
          {error && <p className="number-input__error">{error}</p>}
        </div>

        {/* Info Tooltip */}
        {page.info && (
          <div className="info-box">
            <button
              className="info-box__trigger"
              onClick={() => setShowInfo(!showInfo)}
            >
              <span className="info-box__icon">ℹ️</span>
              {page.info.title}
            </button>
            {showInfo && (
              <div className="info-box__content">
                <p>{page.info.text}</p>
              </div>
            )}
          </div>
        )}

        <div className="page__actions">
            <button
              className="page__button page__button--block"
              onClick={handleSubmit}
              disabled={!value}
            >
              {page.buttonText}
            </button>
        </div>
      </div>
    </div>
  );
};

export default NumberInputPage;
